import useSeo from './useSeo';

const Seo = () => {
  useSeo();
  return null;
};

export default Seo;
